import { EyeInvisibleOutlined, EyeOutlined } from '@ant-design/icons'
import React, { useCallback, useState } from 'react'

interface SSNDisplayProps {
  ssn: string
}

const SSNDisplay: React.FC<SSNDisplayProps> = ({ ssn }) => {
  const [isSSNVisible, setIsSSNVisible] = useState(false)

  const showSSN = useCallback(() => setIsSSNVisible(true), [])
  const hideSSN = useCallback(() => setIsSSNVisible(false), [])

  return (
    <div className="pl-2">
      <div className="mb-2 flex items-center">
        <span className="mr-2 font-medium uppercase">SSN:</span>
        <span className="w-[120px] overflow-hidden text-ellipsis" title={isSSNVisible ? ssn : '***-**-****'}>
          {isSSNVisible ? ssn : '***-**-****'}
        </span>
        <button
          className="ml-2 cursor-pointer border-none bg-transparent p-2"
          onTouchStart={showSSN}
          onTouchEnd={hideSSN}
          onMouseDown={showSSN}
          onMouseUp={hideSSN}
          onMouseLeave={hideSSN}
          aria-label={isSSNVisible ? 'Hide SSN' : 'Show SSN'}
        >
          {isSSNVisible ? <EyeOutlined /> : <EyeInvisibleOutlined />}
        </button>
      </div>
    </div>
  )
}

export default SSNDisplay
